export const maintenanceCategoriesKeys: string[] = [
  'Lightbulb',
  'LightBulb',
  'Bathroom',
  'TVTablet',
  'TvTablet',
  'Plumbing',
  'Cleaning',
  'Batteries',
  'Bed',
  'Env',
  'Other'
]